/**
 * @file Helpers for browser redirects.
 */

/**
 * Redirects the browser to a new URL with the given order id and key as query parameters.
 *
 * @param {string} orderId - The ID of the order.
 * @param {string} orderRef - The reference key of the order.
 * @param {string} lang - The lang parameter for translation if there is one.
 */
export function orderRedirect(orderId: string, orderRef: string, lang: string) {
  window.location.href = `?order_id=${orderId}&order_key=${orderRef}${lang ? `&lang=${lang}` : ""}`;
}

/*
// This function is commented out because it is not being used in the codebase.
// If it comes into use again, please add types and make tests for it.
import appSettings from "../../settings/appSettings";
export default function orderRedirectEcomm(orderPayload, orderResp) {
  const { eventData, orderApiConfig, cobrand } = appSettings;
  const { lineItems = [] } = orderPayload;
  const { orderId, orderRef } = orderResp;
  const hasPhotoUrl = lineItems.some(
    (order) => !!order?.lineMeta?.wvus_product_event_donor_resources
  );
  const photoType = (eventData.PhotoType || "all").toLowerCase();
  const cobrandParam = cobrand ? `&cobrand=${cobrand}` : "";

  if (hasPhotoUrl) {
    window.location.href = `${orderApiConfig.baseUrl}/checkout/order-received/${orderId}?key=${orderRef}${cobrandParam}`;
  } else if (["booth", "all"].includes(photoType)) {
    window.location.href = `${orderApiConfig.baseUrl}/chosen-qr?order_id=${orderId}&order_key=${orderRef}${cobrandParam}`;
  } else {
    window.location.href = `${orderApiConfig.baseUrl}/chosen-photo-options?order_id=${orderId}&order_key=${orderRef}${cobrandParam}`;
  }
}
*/
